import React, { createContext, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import './css/bootstrap-theme.min.css';
import './css/bootstrap.min.css';
// import './css/bootstrap-theme.css';
// import './css/bootstrap.css';
import './css/font-awesome.min.css';
import BaseLayout from "./Layout";
import NotFoundPage from "./pages/NotFoundPage";
// import Otr from "./pages/otr/Otr";
import './css/style.css';
import './css/Responsive.css';
import Kyc from "./pages/Kyc/Kyc";
import { io } from "socket.io-client";
import { adminsocketurl, menuTitleArr, prjName } from "./config";
// import './css/otr.css';
import { hasOtr } from "./config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Otr from "./pages/otr/Otr";
let SocketContext = createContext();


function App() {
  const adminsocket = io(adminsocketurl, {});
  adminsocket.on('connect', function () {
    adminsocket.emit('client', prjName);
  });

  //! //////////////////////////Don't delete OTR code commented below///////////////////////////////

  const [isLoginSubmit, setIsLoginSubmit] = useState(false);

  let otrFetch = localStorage.getItem('otrDetails');
  otrFetch = JSON.parse(otrFetch);

  const onCallSubmit = (data) => {
    if (!!data) {
      setIsLoginSubmit(true);
    }
  }



  return (
    <BrowserRouter>
      <ToastContainer />
      <SocketContext.Provider value={adminsocket}>
        {
          (!!hasOtr && !(!!otrFetch)) ?
            <Otr isLoginDone={(data) => onCallSubmit(data)} />
            :
            <Routes>
              <Route path="/" element={<BaseLayout />}>
                {menuTitleArr?.length > 0 && menuTitleArr?.map((page, index) => {
                  if (!(!!page?.display)) return false;
                  return (
                    <React.Fragment key={index}>
                      <Route path={`/${page?.path}`} element={page?.element} />
                    </React.Fragment>
                  );
                })}
              </Route>
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
        }
      </SocketContext.Provider>
    </BrowserRouter>
  );
}

export { SocketContext };
export default App;
